import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { pageMeta, defaultMeta, SITE_NAME, PageMeta } from '../data/pageMeta';
import { articles } from '../data/articles';
const ARTICLE_PREFIX = '/services/servicenow/thought-leadership/';
function resolveMeta(pathname: string): PageMeta {
  const path = pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;
  if (pageMeta[path]) return pageMeta[path];
  if (path.startsWith(ARTICLE_PREFIX)) {
    const slug = path.slice(ARTICLE_PREFIX.length);
    const article = articles.find(a => a.slug === slug);
    if (article) {
      return {
        title: `${article.title} | ${SITE_NAME}`,
        description: article.excerpt
      };
    }
  }
  return defaultMeta;
}
function setMetaTag(attr: 'name' | 'property', key: string, content: string) {
  let tag = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute(attr, key);
    document.head.appendChild(tag);
  }
  tag.setAttribute('content', content);
}

/** Sets the document title and meta description for the current route. */
export function PageMetaManager() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    const meta = resolveMeta(pathname);
    document.title = meta.title;
    setMetaTag('name', 'description', meta.description);
    setMetaTag('property', 'og:title', meta.title);
    setMetaTag('property', 'og:description', meta.description);
  }, [pathname]);
  return null;
}